// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us-page .contact-us-section {
  padding-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/ContactUs/ContactUsPageStyle.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ","sourcesContent":[".contact-us-page {\n  .contact-us-section {\n    padding-top: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
